import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "./WordSearchComponent.scss";
import {IndexWord} from "../models/models";
import {ServerApi} from "../ServerApi";
import 'react-virtualized/styles.css';



export const RecentWordsComponent: React.FC<any> = () => {
	const [recentWords, setRecentWords] = useState<IndexWord[]>([]);


	useEffect(() => {
		ServerApi
			.getRecentWords()
			.then(words => setRecentWords(words));
	}, []);


	return (
		<div>
			<h3>최근 등록 용어</h3>

			<ul style={{paddingLeft: "15px"}}>
				{recentWords.map(w =>
					<li key={w.id}>
						<Link to={`/${w.id}`}
						      style={{display: "block", textDecoration: "none", color: "black", marginBottom: "10px"}}>
							{w.term}
						</Link>
					</li>
				)}
			</ul>
		</div>
	)
};